
HTMLElement.prototype.wraping = function () {
    let k = this

    if (!k.parentElement.classList.contains('w-a-c')) {

        let b = document.createElement('div');
        b.innerHTML = `<div class="w-a-c" style='position: relative; overflow: hidden'></div>`;
        b = b.firstChild;

        let i = k.length ? k[0] : k;

        // Cache the current parent and sibling of the first element.
        let p = i.parentNode;
        let s = i.nextSibling;

        // Wrap the first element (is automatically removed from its
        // current parent).
        b.appendChild(i);

        // Wrap all other elements (if applicable). Each element is
        // automatically removed from its current parent and from the k
        // array.
        while (k.length) {
            b.appendChild(k[0]);
        }

        // If the first element had a sibling, insert the b before the
        // sibling to maintain the HTML structure; otherwise, just append it
        // to the parent.
        if (s) {
            p.insertBefore(b, s);
        } else {
            p.appendChild(b);
        }
    }
};


function generateProductDetailCollapsible() {
    const groups = [
        {
            label: '.desc_label',
            arrow: '.desc_svg',
            content: '.desc_content',
        },
        {
            label: '.material_label',
            arrow: '.material_svg',
            content: '.material_content',
        },
        {
            label: '.size_label',
            arrow: '.size_svg',
            content: '.size_content',
        }
    ]

    groups.map((group) => {
        $(group.arrow).on('click', function () {
            $(group.content).toggleClass('meta-hide');
            $(group.arrow).toggleClass('rotate-open');
        });
    })
}

function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
}

function animateFrom(elem) {
    let toAnimate;

    // ini kalau ada jadikan animasi berantai kalau ada anak dengan class type_display
    const childDisplay = elem.querySelectorAll('.type_display');
    if (childDisplay.length > 0) {
        toAnimate = childDisplay
    }
    // ini kalau tidak ada anak
    else {
        toAnimate = elem
    }

    // check multiple animate (kalau anakan)
    if(toAnimate.length > 0) {
        for (let i = 0; i < toAnimate.length; i++) {
            runAnimation(toAnimate[i])
        }
    }
    else {
        runAnimation(toAnimate)
    }
}

function runAnimation(toAnimate) {
    let animationType = 'general'
    try {
        if(toAnimate.classList.contains('image__img')){
            if(toAnimate.offsetWidth / window.screen.availWidth > 0.5) {
                animationType = false
            }
            else {
                animationType = 'swipe'
            }
        }
    } catch (error) {
    }
    
    switch (animationType) {
        case 'general':
            animateGeneral(toAnimate)
            break;
        
        case 'swipe':
            animateSwipe(toAnimate)
            break;
    
        default:
            break;
    }
}

function animateGeneral(e) {
    let x = 0,
        y = '100%',
        duration = 1.5,
        X = 0, 
        Y = 0;

    e.style.transform = "translate(" + x + "px, " + y + "px)";
    e.style.opacity = "0";

    if(!e.classList.contains('image__img')) {
        e.wraping()
    }
    
    hide(e);
    setTimeout(() => {
        gsap.fromTo(e, { x: x, y: y, autoAlpha: 0 }, {
            duration: duration,
            x: X,
            y: Y,
            autoAlpha: 1,
            ease: "expo",
            overwrite: "auto",
            stagger: 0.15
        });
    }, 500)
}

function animateSwipe(toAnimate) {
    let isWorking = toAnimate.classList.contains('beingAnimated');

    if(!isWorking) {
        toAnimate.classList.add('beingAnimated')
        const duration = 0.3
        const targetFps = 60
        let delay = 1000/targetFps
        let totalFrame = duration*targetFps
    
        function animate(pos, totalFrame, currentFrame, interval) {
            toAnimate.style['-webkit-mask-image'] = `linear-gradient(to bottom, #0000000d ${pos}%, #000000b0 ${pos}%)`;
            console.log('currentFrame', currentFrame);
            if(currentFrame > 0) {
                setTimeout(() => {
                    pos = pos - (100/totalFrame)
                    animate(pos, totalFrame, currentFrame-1, interval)
                }, interval)
            }
            else{
                toAnimate.classList.remove('beingAnimated')
            }
        }
    
        let pos = 100;
        animate(pos, totalFrame, totalFrame, delay)
    }

}

function onSlideShowNavigate(section) {
        const toHide = document.querySelectorAll(`#${section} .gallery__slide.carousel__slide .slideshow__slideshow__gallery .gallery__description`).forEach(e=>{
            e.style.opacity = "0"
        })

        setTimeout(()=>{
            animateGeneral(document.querySelector(`#${section} .gallery__slide.carousel__slide.is-selected .slideshow__slideshow__gallery .gallery__description`))
        }, 300)
}

(function ($) {
    $('#filter_tag_blog').on('click', function (e) {
        $('.filter-blog-wrap').toggleClass("active");
    });

    $('#close-filter').on('click', function (e) {
        $('.filter-blog-wrap').removeClass("active");
    });

    $(".filter-item-blog").click(function () {
        $('.filter-item-blog').removeClass('active'); // remove first
        $(this).addClass('active');
    });

    $('#btn-clear-blog').on('click', function (e) {
        $('.filter-item-blog').removeClass('active');
    });

    $("#btn-apply-blog").click(function () {
        var getvalueActive = jQuery('.collection-flyout__content ul').find('.active').children().attr('data-value');
        location.href = getvalueActive;
        $('.filter-blog-wrap').removeClass("active");
    });

    generateProductDetailCollapsible();

    document.addEventListener("DOMContentLoaded", function () {
        gsap.registerPlugin(ScrollTrigger);

        // const elems = gsap.utils.toArray("body.template-index- h2, body.template-index- .gallery__description.slideshow--gallery , body.template-index- .image__img");
        const elems = gsap.utils.toArray("body.template-index- h2, body.template-blog h2, body.template-collection h2, .list-collections h1, .blog__article-title, .product-page-wrapper h1, .slideshow__slideshow__gallery>.gallery__description, body.template-index- .image__img");
        elems.forEach(function (elem) {// assure that the element is hidden when scrolled into view

            ScrollTrigger.create({
                trigger: elem,
                onEnter: function () { 
                    if(!elem.classList.contains('animated')) {
                        elem.classList.add('animated')
                        animateFrom(elem) 
                    }
                },
                // onEnterBack: function() { animateFrom(elem, -1) },
                // onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
            });
        });
    });

})(jQuery);